export default "__VITE_ASSET__DCTBlN1n__"